import type {Context} from '../types';

// Fix legacy lightbox group
export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;
  const group = data.json && data.json.groupId;

  return {
    needed: data.lightbox && group,
    logData: {
      msg: 'Lightbox with data.json.groupId',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      data.json.group = group;
      // eslint-disable-next-line webflow/no-delete
      delete data.json.groupId;
    },
  };
};
